import type { GetRequestOptions, IFetchService, PostConfigObject } from "app/services/fetchService";

import type { IFiltersSelectionDto } from "../../types/dto";

const BASE_DESCRIPTION_PATH = "/sales-api/advanced-search/description";

const createAdvancedSearchFilteringApiService = (fetchService: IFetchService) => {
    return {
        fetchFiltersSelection(options?: Readonly<GetRequestOptions>): Promise<IFiltersSelectionDto> {
            return fetchService.get(`${BASE_DESCRIPTION_PATH}/filters/selection`, undefined, options);
        },

        setPinnedFilters(dto: IFiltersSelectionDto, config?: PostConfigObject): Promise<void> {
            return fetchService.put(`${BASE_DESCRIPTION_PATH}/filters/selection`, dto, config);
        },
    };
};

export default createAdvancedSearchFilteringApiService;
